/* DezLin New Arrivals — page interactivity
 *
 * Handles:
 *   1. Tab switching (Just Landed / Back in Stock / On Sale)
 *   2. Days slider — filters Just Landed by published_at threshold
 *   3. Live counter strip — updates counts per tab from rendered grid
 *   4. Add-to-Cart with green success indicator + qty morph + "X left" fade
 *   5. Notify When Back inline email form (sold-out cards)
 *   6. Sort dropdown (newest / price asc / price desc)
 *   7. Deep-link via URL hash (#back-in-stock, #on-sale)
 */

(function () {
  'use strict';

  function init() {
    var section = document.querySelector('.dz-na');
    if (!section) return;

    var STOCK_FADE_MS = 2500;
    var ADDED_FADE_MS = 2200;
    var tabs = section.querySelectorAll('.dz-na-tab');
    var panels = section.querySelectorAll('[data-tab-panel]');
    var slider = section.querySelector('[data-na-slider]');
    var readout = section.querySelector('[data-na-readout]');
    var presets = section.querySelectorAll('.dz-na-days-preset');
    var sortSelect = section.querySelector('[data-na-sort]');

    // Set initial active tab on section root for CSS rules
    var initialActiveTab = section.querySelector('.dz-na-tab--active');
    if (initialActiveTab) {
      section.setAttribute('data-active-tab', initialActiveTab.dataset.tab);
    }

    // ── Tab switching ──────────────────────────────────────
    function activateTab(tabKey) {
      tabs.forEach(function (t) {
        var active = t.dataset.tab === tabKey;
        t.classList.toggle('dz-na-tab--active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        if (p.dataset.tabPanel === tabKey) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      // Mark the section root with the active tab so CSS can hide controls
      // that are only relevant for date-based tabs (just-landed, back-in-stock).
      section.setAttribute('data-active-tab', tabKey);
      checkEmptyStates();
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activateTab(t.dataset.tab); });
    });

    var hash = (window.location.hash || '').replace('#', '');
    if (hash === 'back-in-stock' || hash === 'on-sale' || hash === 'just-landed' || hash === 'only-a-few-left') {
      activateTab(hash);
    }

    section.querySelectorAll('[data-jump-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () { activateTab(btn.dataset.jumpTab); });
    });

    // ── Days slider ────────────────────────────────────────
    function applyDaysFilter(days) {
      var nowSec = Math.floor(Date.now() / 1000);
      var cutoff = nowSec - (days * 86400);
      var justLandedPanel = section.querySelector('[data-tab-panel="just-landed"]');
      if (!justLandedPanel) return;
      var items = justLandedPanel.querySelectorAll('.dz-na-grid-item');
      var visibleCount = 0;
      items.forEach(function (item) {
        var ts = parseInt(item.dataset.publishedTs, 10);
        if (!ts) return;
        if (ts >= cutoff) {
          item.style.display = '';
          visibleCount++;
        } else {
          item.style.display = 'none';
        }
      });
      updateCount('just-landed', visibleCount);
      checkEmptyStates();
    }

    function setDaysReadout(n) {
      if (!readout) return;
      var suffixEl = readout.querySelector('.dz-na-days-suffix');
      var suffix = (n + '' === '365' || n + '' === '364') ? 'd (1y)' : 'd';
      readout.firstChild.nodeValue = n;
      if (suffixEl) suffixEl.textContent = suffix;
      if (slider) {
        var min = parseInt(slider.min || 7, 10);
        var max = parseInt(slider.max || 365, 10);
        var pct = ((n - min) / (max - min)) * 100;
        slider.style.background = 'linear-gradient(to right, var(--dz-pacific) 0%, var(--dz-pacific) ' + pct + '%, var(--dz-gray-200) ' + pct + '%, var(--dz-gray-200) 100%)';
      }
      presets.forEach(function (p) {
        p.classList.toggle('dz-na-days-preset--active', p.dataset.days === n + '');
      });
    }

    function applyBackInStockFilter(days) {
      var nowSec = Math.floor(Date.now() / 1000);
      var cutoff = nowSec - (days * 86400);
      var bisPanel = section.querySelector('[data-tab-panel="back-in-stock"]');
      if (!bisPanel) return;
      var items = bisPanel.querySelectorAll('.dz-na-grid-item');
      var visibleCount = 0;
      items.forEach(function (item) {
        var ts = parseInt(item.dataset.backinstockTs, 10);
        if (!ts) { item.style.display = ''; visibleCount++; return; }
        if (ts >= cutoff) { item.style.display = ''; visibleCount++; }
        else { item.style.display = 'none'; }
      });
      updateCount('back-in-stock', visibleCount);
      checkEmptyStates();
    }

    if (slider) {
      slider.addEventListener('input', function (e) {
        var n = parseInt(e.target.value, 10);
        setDaysReadout(n);
        applyDaysFilter(n);
        applyBackInStockFilter(n);
      });
      setDaysReadout(slider.value);
      applyDaysFilter(parseInt(slider.value, 10));
      applyBackInStockFilter(parseInt(slider.value, 10));
    }
    presets.forEach(function (p) {
      p.addEventListener('click', function () {
        var n = parseInt(p.dataset.days, 10);
        if (slider) slider.value = n;
        setDaysReadout(n);
        applyDaysFilter(n);
        applyBackInStockFilter(n);
      });
    });

    // ── Live counter ───────────────────────────────────────
    function countTab(tabKey) {
      var panel = section.querySelector('[data-tab-panel="' + tabKey + '"]');
      if (!panel) return 0;
      var items = panel.querySelectorAll('.dz-na-grid-item');
      var n = 0;
      items.forEach(function (item) {
        if (item.style.display !== 'none') n++;
      });
      return n;
    }
    function updateCount(tabKey, n) {
      var els = section.querySelectorAll('[data-na-count="' + tabKey + '"]');
      els.forEach(function (el) { el.textContent = n; });
    }
    function refreshAllCounts() {
      ['just-landed', 'back-in-stock', 'on-sale', 'only-a-few-left'].forEach(function (key) {
        updateCount(key, countTab(key));
      });
    }
    refreshAllCounts();

    // ── Empty states ───────────────────────────────────────
    function checkEmptyStates() {
      panels.forEach(function (panel) {
        var visibleItems = 0;
        panel.querySelectorAll('.dz-na-grid-item').forEach(function (item) {
          if (item.style.display !== 'none') visibleItems++;
        });
        var empty = panel.querySelector('.dz-na-empty');
        if (empty) {
          if (visibleItems === 0) empty.removeAttribute('hidden');
          else empty.setAttribute('hidden', '');
        }
      });
    }
    checkEmptyStates();

    // ── Sort dropdown ──────────────────────────────────────
    function applySort(sortKey) {
      panels.forEach(function (panel) {
        var grid = panel.querySelector('.dz-na-grid');
        if (!grid) return;
        var items = Array.from(grid.querySelectorAll('.dz-na-grid-item'));
        items.sort(function (a, b) {
          if (sortKey === 'newest') {
            return parseInt(b.dataset.publishedTs || 0, 10) - parseInt(a.dataset.publishedTs || 0, 10);
          }
          if (sortKey === 'price-asc' || sortKey === 'price-desc') {
            var aPrice = parsePrice(a.querySelector('.card-wrapper'));
            var bPrice = parsePrice(b.querySelector('.card-wrapper'));
            return sortKey === 'price-asc' ? aPrice - bPrice : bPrice - aPrice;
          }
          return 0;
        });
        items.forEach(function (item) { grid.appendChild(item); });
      });
    }
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        applySort(sortSelect.value);
      });
      // Run the default sort once on page load so the rendered cards reflect
      // the dropdown's pre-selected value (Newest first → sort by published_at desc).
      applySort(sortSelect.value);
    }
    function parsePrice(card) {
      if (!card) return 0;
      var priceEl = card.querySelector('.dz-price');
      if (!priceEl) return 0;
      var t = priceEl.textContent || '';
      return parseFloat(t.replace(/[^0-9.]/g, '')) || 0;
    }

    // ── Wholesale Add to Cart — handles <add-to-cart data-variant-id=""> in merged card ──
    section.addEventListener('click', function (e) {
      var atcEl = e.target.closest('add-to-cart[data-variant-id]');
      if (!atcEl) return;
      var variantId = atcEl.dataset.variantId;
      if (!variantId) return;
      var widget = atcEl.closest('.wq-card-widget');
      var qtyInput = widget ? widget.querySelector('.quantity__input') : null;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (qty < 1) qty = 1;
      addToCart(variantId, qty, function () {
        var origText = atcEl.textContent.trim();
        atcEl.textContent = '✓ Added';
        setTimeout(function () { atcEl.textContent = origText; }, 1800);
      });
    });

    // ── Add-to-Cart morph + success indicator (legacy .dz-card — kept for reference) ──
    section.querySelectorAll('.dz-card').forEach(function (card) {
      var addBtn = card.querySelector('.dz-qa-add');
      var qtyBlock = card.querySelector('.dz-qa-qty');
      var stockEl = card.querySelector('.dz-qa-stock');
      var addedEl = card.querySelector('.dz-qa-added');
      if (!addBtn || !qtyBlock || !stockEl || !addedEl) return;

      var stock = parseInt(addBtn.dataset.stock, 10) || 999;
      var variantId = addBtn.dataset.variantId;
      var qtyVal = qtyBlock.querySelector('.dz-qa-val');
      var minusBtn = qtyBlock.querySelector('.dz-qa-minus');
      var plusBtn = qtyBlock.querySelector('.dz-qa-plus');
      var fadeTimer = null;
      var addedTimer = null;

      function showStock(qty) {
        if (stock < 100) {
          var remaining = stock - qty;
          if (remaining < 0) remaining = 0;
          stockEl.textContent = remaining + ' left';
          stockEl.classList.toggle('dz-qa-stock--low', remaining > 0 && remaining <= 5);
          stockEl.classList.remove('dz-qa-stock--fading');
          stockEl.removeAttribute('hidden');
          clearTimeout(fadeTimer);
          fadeTimer = setTimeout(function () {
            stockEl.classList.add('dz-qa-stock--fading');
          }, STOCK_FADE_MS);
        }
      }

      function showAdded() {
        addedEl.classList.remove('dz-qa-added--fading');
        addedEl.removeAttribute('hidden');
        clearTimeout(addedTimer);
        addedTimer = setTimeout(function () {
          addedEl.classList.add('dz-qa-added--fading');
        }, ADDED_FADE_MS);
      }

      function setQty(n, delta) {
        if (n < 1) n = 1;
        if (n > stock) n = stock;
        var prev = parseInt(qtyVal.dataset.qty, 10) || 1;
        qtyVal.dataset.qty = n;
        qtyVal.textContent = n;
        showStock(n);
        // If qty went up, add the delta to cart. If down, decrement.
        if (delta && delta !== 0) {
          if (delta > 0) addToCart(variantId, delta, showAdded);
          else changeCart(variantId, n);
        }
      }

      addBtn.addEventListener('click', function () {
        addBtn.setAttribute('hidden', '');
        qtyBlock.removeAttribute('hidden');
        qtyVal.dataset.qty = 1;
        qtyVal.textContent = '1';
        showStock(1);
        addToCart(variantId, 1, showAdded);
      });

      minusBtn.addEventListener('click', function () {
        var cur = parseInt(qtyVal.dataset.qty, 10);
        setQty(cur - 1, -1);
      });
      plusBtn.addEventListener('click', function () {
        var cur = parseInt(qtyVal.dataset.qty, 10);
        setQty(cur + 1, 1);
      });
    });

    // Shopify Ajax Cart API + Section Rendering — adds item AND refreshes cart drawer/bubble in one round-trip.
    function addToCart(variantId, quantity, onSuccess) {
      if (!variantId) {
        console.warn('[dz-new-arrivals] addToCart: missing variantId');
        alert('Could not add: missing variant ID. Refresh the page and try again.');
        return;
      }
      console.log('[dz-new-arrivals] adding variant', variantId, 'qty', quantity);

      // Use FormData + sections param so Shopify returns rendered HTML for the cart drawer + bubble.
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', quantity);
      fd.append('sections', 'cart-drawer,cart-icon-bubble,cart-live-region-text');
      fd.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          return r.text().then(function (text) {
            return { ok: r.ok, status: r.status, statusText: r.statusText, text: text };
          });
        })
        .then(function (resp) {
          if (!resp.ok) {
            var errMsg = resp.text;
            try {
              var parsed = JSON.parse(resp.text);
              errMsg = parsed.description || parsed.message || parsed.error || JSON.stringify(parsed);
            } catch (e) { /* not JSON */ }
            console.warn('[dz-new-arrivals] cart add failed', resp.status, errMsg);
            alert('Could not add to cart (HTTP ' + resp.status + '): ' + errMsg);
            return;
          }
          console.log('[dz-new-arrivals] cart add succeeded');

          var data = {};
          try { data = JSON.parse(resp.text); } catch (e) {}

          // 1. Replace cart drawer + bubble HTML if Shopify returned rendered sections
          if (data.sections) {
            replaceSectionHtml('cart-drawer', data.sections['cart-drawer']);
            replaceSectionHtml('cart-icon-bubble', data.sections['cart-icon-bubble']);
            replaceSectionHtml('cart-live-region-text', data.sections['cart-live-region-text']);
          }

          // 2. Open Be Yours cart drawer if present
          tryOpenCartDrawer();

          // 3. Always refresh cart count as safety net (in case section rendering doesn't include the bubble)
          refreshCartCount();

          // 4. Dispatch all known theme events
          ['cart:update', 'cart:added', 'on:cart:after-merge', 'cart:refresh'].forEach(function (evt) {
            document.dispatchEvent(new CustomEvent(evt, { detail: data }));
          });

          if (onSuccess) onSuccess();
        })
        .catch(function (err) {
          console.warn('[dz-new-arrivals] cart add network error', err);
          alert('Could not reach cart: ' + (err && err.message ? err.message : err));
        });
    }

    // Replace a section's HTML in the DOM with the freshly-rendered version from Shopify.
    function replaceSectionHtml(sectionId, freshHtml) {
      if (!freshHtml) return;
      // Shopify wraps sections in #shopify-section-{sectionId}; replace that node's inner HTML.
      var existing = document.getElementById('shopify-section-' + sectionId);
      if (!existing) {
        // Sometimes the section ID is partial — try class-based selector
        existing = document.querySelector('[id*="' + sectionId + '"]');
      }
      if (!existing) return;
      try {
        var temp = document.createElement('div');
        temp.innerHTML = freshHtml.trim();
        var newSection = temp.firstElementChild;
        if (newSection && newSection.id) {
          existing.outerHTML = newSection.outerHTML;
        } else {
          existing.innerHTML = freshHtml;
        }
        console.log('[dz-new-arrivals] refreshed section:', sectionId);
      } catch (e) {
        console.warn('[dz-new-arrivals] section replace failed:', sectionId, e);
      }
    }

    // Be Yours theme uses a custom element <cart-drawer> with an open() method.
    // Try multiple selectors in case the structure differs.
    function tryOpenCartDrawer() {
      var drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer, [is="cart-drawer"]');
      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open();
          console.log('[dz-new-arrivals] opened cart drawer via .open()');
          return;
        }
        // Some themes use class-based open state
        drawer.classList.add('is-open', 'active', 'is-active', 'open');
        document.body.classList.add('cart-open', 'overflow-hidden');
      }
      // Last resort: dispatch an event Be Yours might listen for
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    }

    // Fetch cart count and update header bubble. Safety net in case section rendering misses it.
    function refreshCartCount() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count || 0;
          var selectors = [
            '.cart-count-bubble span',
            '.cart-count-bubble',
            '[data-cart-count]',
            '.header__cart-count',
            'cart-count',
            '.cart__count',
            '.site-header__cart-count',
            '.js-cart-count'
          ];
          selectors.forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) {
              el.textContent = count;
              el.style.display = count > 0 ? '' : 'none';
              el.removeAttribute('hidden');
            });
          });
          console.log('[dz-new-arrivals] cart count refreshed:', count);
        })
        .catch(function (err) {
          console.warn('[dz-new-arrivals] cart count fetch failed', err);
        });
    }

    // Shopify Ajax Cart API: set absolute quantity for a variant
    function changeCart(variantId, quantity) {
      if (!variantId) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity }),
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) console.warn('[dz-new-arrivals] cart change failed', r.status);
          document.dispatchEvent(new CustomEvent('cart:update'));
        })
        .catch(function (err) {
          console.warn('[dz-new-arrivals] cart change error', err);
        });
    }

    // ── Notify When Back inline form ───────────────────────
    section.querySelectorAll('.dz-card').forEach(function (card) {
      var notifyBtn = card.querySelector('.dz-qa-notify');
      var notifyForm = card.querySelector('.dz-qa-notify-form');
      var notifySuccess = card.querySelector('.dz-qa-notify-success');
      if (!notifyBtn || !notifyForm) return;

      var emailInput = notifyForm.querySelector('.dz-qa-notify-email');
      var cancelBtn = notifyForm.querySelector('.dz-qa-notify-cancel');
      var variantId = notifyBtn.dataset.variantId;
      var productHandle = card.dataset.productHandle;

      notifyBtn.addEventListener('click', function () {
        notifyBtn.setAttribute('hidden', '');
        notifyForm.removeAttribute('hidden');
        if (emailInput) emailInput.focus();
      });

      if (cancelBtn) {
        cancelBtn.addEventListener('click', function () {
          notifyForm.setAttribute('hidden', '');
          notifyBtn.removeAttribute('hidden');
        });
      }

      notifyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailInput.value || '').trim();
        if (!email) return;

        // Submit to back-in-stock subscription endpoint.
        // TODO: when Kbite's public subscribe API endpoint is confirmed (or when
        // DezLin Reveals cutover happens), wire this fetch to that real endpoint.
        // For now: log the subscription locally + show success without leaving the page.
        var subscription = {
          email: email,
          variant_id: variantId,
          product_handle: productHandle,
          subscribed_at: new Date().toISOString()
        };
        console.log('[dz-new-arrivals] back-in-stock subscription queued', subscription);

        // Persist to localStorage as a queue Claude can sync to Kbite/Reveals later
        try {
          var queue = JSON.parse(localStorage.getItem('dz_bis_queue') || '[]');
          queue.push(subscription);
          localStorage.setItem('dz_bis_queue', JSON.stringify(queue));
        } catch (e) { /* localStorage unavailable, no-op */ }

        // Show success state, stay on page (per Marc's request)
        notifyForm.setAttribute('hidden', '');
        if (notifySuccess) notifySuccess.removeAttribute('hidden');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
